export default "__VITE_ASSET__C7n4$bvX__"